import { render, staticRenderFns } from "./CallSettingsModal.vue?vue&type=template&id=7a2f5154&scoped=true&"
import script from "./CallSettingsModal.vue?vue&type=script&lang=js&"
export * from "./CallSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./CallSettingsModal.vue?vue&type=style&index=0&id=7a2f5154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2f5154",
  null
  
)

export default component.exports